import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import logoImg from '../../template/utils/images/VectorB.png';


const GuestNavigationBar = (props) => {
  const {
    className2,
    children,
  } = props;

  return (

    <div>
      <div className="index_nav_div_container">
        <div className="index_nav_div">
          <div className="left_nav_items">
            <ul className="list_link">
              <li>
                <Link
                  to="/"
                >
                  <img
                    src={logoImg}
                    alt="logo"
                    style={{ height: '41px', width: '42px', marginTop: '-12px' }}
                  />
                  <span style={{ display: 'inline-flex', fontSize: '25px', fontFamily: 'meristem_bold', fontWeight: 'bold', marginLeft: '10px', marginTop: '6px' }}>Wealthbuddy</span>
                </Link>
              </li>
              <div className="list_link">
                <li>
                  <NavLink className="each_list_link each"
                    to="/invest"
                    activeClassName="active"
                  >
                  Invest
                  </NavLink>
                </li>

                <li>
                  <NavLink to="/save" className="each_list_link" activeClassName="active">
                  Save
                  </NavLink>
                </li>

                <li>
                  <NavLink to="/learn" className="each_list_link" activeClassName="active">
                  Learn
                  </NavLink>
                </li>

                <li>
                  <NavLink to="/goals" className="each_list_link" activeClassName="active">
                  Goals
                  </NavLink>
                </li>
              </div>
            </ul>

          </div>
          <div className="right_nav_items">

            <ul>
              <li>
                <Link to="login">
                Login
                </Link>
              </li>

              <li>
                <Link to="/signup" className="register_link">
                Create free account
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="open_nav_btn">
        <span className="sideNavBtnOpen">&#9776;</span>
        {/* <img src={logoImgSmall} alt="" /> */}
      </div>
      <div className={className2}>
        {children}
      </div>
    </div>
  );
};

GuestNavigationBar.propTypes = {
  className2: PropTypes.string,
  children: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.any]))
};

export default GuestNavigationBar;
